import React, { Component } from "react";
import { post } from "@aws-amplify/api";
import Utils from './../../utils.js';

class SummaryLiberty extends Component {
  state = {
    showRedirectMessage: false,
    showSpinner: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isSubmit: false
    };
  }

  isValidated() {

    if (this.props.getStore().isSubmit === true) {
      this.setState({ isSubmit: true });
      return false;
    }

    if (this.state.isSubmit === true) {
      return false;
    }
  };

  // Method to check if all required fields are filled
  areAllFieldsValid = () => {
    const data = this.props.getStore();
    const requiredFields = ['virtualPath', 'targetPath', 'targetHost', 'productName', 'environment', 'buildEnvironment', 'subBU', 'adGroup'];

    return requiredFields.every(field =>
      data[field] && data[field].toString().trim() !== ''
    );
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmit: true, showSpinner: true }); // Show spinner immediately
    let data = this.props.getStore();

    // Validate required fields
    const requiredFields = [
      { field: 'virtualPath', name: 'Virtual Path' },
      { field: 'targetPath', name: 'Target Path' },
      { field: 'targetHost', name: 'Target Host' },
      { field: 'productName', name: 'Proxy Group Name' },
      { field: 'environment', name: 'Deployment Environment' },
      { field: 'buildEnvironment', name: 'Build Environment' },
      { field: 'subBU', name: 'Sub BU' },
      { field: 'adGroup', name: 'AD Group' }
    ];

    const missingFields = requiredFields.filter(({ field }) =>
      !data[field] || data[field].toString().trim() === ''
    );

    if (missingFields.length > 0) {
      const missingFieldNames = missingFields.map(({ name }) => name).join(', ');
      alert(`Please fill in all required fields: ${missingFieldNames}`);
      this.setState({ isSubmit: false, showSpinner: false });
      return;
    }

    const apiName = "Send Liberty Approval API";
    const path = "/send-liberty-approval";
    try {

      const buildBody = {
          virtualPath: data.virtualPath,
          buildEnvironment: data.buildEnvironment,
          targetPath: data.targetPath,
          targetHost: data.targetHost,
          deploymentEnvironment: data.environment,
          subBU: data.subBU,
          proxyGroupName: data.productName,
          adGroup: data.adGroup,
          domainName: window.location.hostname,
          createdAt: Date.now().toString(),
          isNewProduct: this.props.getStore().isNewProduct
        };

      // Await the response and access the body
      const response = await Utils.fetchLambdaApis(apiName, path, buildBody);

      // Handle the workflow response
      return this.handleWorkflowResponse(response);
    } catch (error) {
      console.error("API error:", error);
      if (error.response && error.response.body) {
        try {
          const errorResponseData = await error.response.body.json();
          console.error("Error response body:", errorResponseData);
        } catch (parseError) {
          console.error(
            "Could not parse error response body:",
            error.response.body
          );
        }
      }
      alert("Failed to trigger workflow. Please try again.");
      this.setState({ isSubmit: false, showSpinner: false }); // Hide spinner only on error
    }
  };

  handleWorkflowResponse = (response) => {
    const workflowRunUrl = response.workflowRunUrl;
    if (workflowRunUrl) {
      this.setState({ showRedirectMessage: true });
      setTimeout(() => {
        window.location.href = workflowRunUrl;
      }, 200);
    } else {
      console.error("Workflow Run URL not found in response:", response);
      this.setState({ showSpinner: false }); // Hide spinner if no redirect
      alert("Workflow triggered, but could not find the workflow run URL.");
    }
  };

  render() {
    let data = this.props.getStore();

    return (
      <div style={{ position: "relative" }}>
        {this.state.showSpinner && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(255,255,255,0.7)",
                zIndex: 9999,
                backdropFilter: "blur(3px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{ width: 60, height: 60, marginBottom: 20 }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <div
                  style={{ fontWeight: "bold", color: "#007bff", fontSize: 18 }}
                >
                  Please wait while we redirect you to GitHub...
                </div>
              </div>
            </div>
          </>
        )}
        <div
          style={
            this.state.showSpinner
              ? {
                filter: "blur(3px)",
                pointerEvents: "none",
                userSelect: "none",
              }
              : {}
          }
        >
          <div className="container util-margin-top-50">
            {!this.areAllFieldsValid() && (
              <p className="alert alert-danger util-margin-top-10">
                <strong>Missing Information:</strong> Some parameters are missing. Please provide all required information to proceed with the submission.
              </p>
            )}
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Virtual Path: </span>
              </div>
              <div className="col-md-6">
                <span>{data.virtualPath}</span>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Target Path: </span>
              </div>
              <div className="col-md-6">
                <span>{data.targetPath}</span>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Target Host: </span>
              </div>
              <div className="col-md-6">
                <span>{data.targetHost}</span>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Deployment Environment: </span>
              </div>
              <div className="col-md-6">
                <span>{data.environment}</span>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Build Environment: </span>
              </div>
              <div className="col-md-6">
                <span>{data.buildEnvironment}</span>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Sub BU: </span>
              </div>
              <div className="col-md-6">
                <span>{data.subBU}</span>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <span>Proxy Group Name: </span>
              </div>
              <div className="col-md-6">
                <span>{data.productName}</span>
              </div>
            </div>
            <div className="row">
              <hr />
              <div className="col-md-3">
                <span>AD Group: </span>
              </div>
              <div className="col-md-6">
                <span>{data.adGroup}</span>
              </div>
            </div>
            <hr />
          </div>
          <button
            disabled={this.state.isSubmit || !this.areAllFieldsValid()}
            className="btn btn-primary btn-sm pull-right util-margin-top-50"
            onClick={this.onSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}

export default SummaryLiberty;
